/// all api for approve setting page
import API from "../api";
import { API_GROUPS } from "../constants/api";

async function getGroupRelations(level, data) {
  try {
    const response = await API.get(
      API_GROUPS + '/level/' + level,
      {params: data}
    );
    return response.data
  } catch (e) {
    throw e.response;
  }
}

async function addGroup(data, level) {
  const sumbitData = {
    'group_1': data[1],
    'group_2': data[2],
    'group_3': data[3],
    'group_4': data[4],
    'group_5': data[5],
    'active': data.active,
    'level': level,
  }

  const headers = {
    'Content-Type': 'application/json; charset=utf-8'
  }

  try {
    let response;
    response = await API.post(
      API_GROUPS,
      {data: JSON.stringify(sumbitData)},
      headers
    );
    return response.data
  } catch (e) {
    throw e;
  }
}

async function editGroup(data, level) {
  const sumbitData = {
    'group_1': data[1],
    'group_2': data[2],
    'group_3': data[3],
    'group_4': data[4],
    'group_5': data[5],
    'active': data.active,
    'level': level,
    'id': data.id
  }

  const headers = {
    'Content-Type': 'application/json; charset=utf-8'
  }

  try {
    let response;
    response = await API.put(
      API_GROUPS,
      {data: JSON.stringify(sumbitData)},
      headers
    );
    return response.data
  } catch (e) {
    throw e;
  }
}

async function deleteGroups(ids) {
  const headers = {
    'Content-Type': 'application/json'
  };

  try {
    if (ids) {
      let response = await API.delete(
        API_GROUPS, {
          headers: headers,
          data: {
            ids: ids
          }
        }
      );
      return response.data
    }
  } catch (e) {
    throw e.response;
  }
}


const MachineGroupServices = {
  addGroup,
  editGroup,
  deleteGroups,
  getGroupRelations
};

export { 
  MachineGroupServices as default,
  addGroup,
  editGroup,
  deleteGroups,
  getGroupRelations,
};
